import React from 'react'

interface RememberMeFieldProps {
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
  className?: string
}

const RememberMeField: React.FC<RememberMeFieldProps> = ({
  checked,
  onChange,
  id = 'remember-me',
  className = 'form-options',
}) => {
  if (className === 'admin-login-form') {
    return (
      <div className="form-group remember-me-group">
        <label className="checkbox-wrapper" htmlFor={id}>
          <input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span className="checkmark"></span>
          Remember me
        </label>
      </div>
    )
  }

  return (
    <label className="checkbox-wrapper" htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="checkmark"></span>
      Remember me
    </label>
  )
}

export default RememberMeField
